<template>
  <v-row>
    <meta name="chrome-autofill" content="on" />
    <v-col class="mx-auto" cols="11" md="4">
      <div
        class="align-center text-center flex-column mb-10"
        :width="widthPrincipal"
      >
        <h1>Finalização de pedido</h1>
        <template
          v-for="(produto, index) in mutableCarrinho"
          :key="produto.verificador"
        >
          <!-- Combos -->
          <div
            v-if="
              produto.quantidade >= 1 &&
              !produto.tamanhoUnic &&
              !produto.tamanhoComp
            "
            class="d-flex align-center flex-column mb-10 text-left"
          >
            <v-card class="mt-2 pb-3" width="100%">
              <v-row align="center">
                <v-col cols="4">
                  <div class="ml-3 mt-2 mb-2 rounded">
                    <img
                      :style="
                        'width: 100px; height: 125px; border-radius: 8px; border: 0.5px solid' +
                        dadosEmpresa.corBase +
                        '; object-fit: cover;'
                      "
                      :src="produto.img_url"
                    />
                  </div>
                </v-col>
                <v-col cols="8">
                  <v-card-title class="pa-0">{{ produto.nome }}</v-card-title>
                  <p class="pa-0" style="opacity: 60%">
                    {{ produto.descricao }}
                  </p>
                  <div
                    :style="
                      'border: 1px solid white; color: ' +
                      dadosEmpresa.corBase +
                      '; border-radius: 5px'
                    "
                    v-if="
                      produto.tempoExtra &&
                      produto.tempoExtra.ativo == true &&
                      this.selecionado == 'Encomendas'
                    "
                  >
                    Este combo necessita de no mínimo
                    {{ produto.tempoExtra.dias }} para ser entregue
                  </div>
                  <p style="opacity: 60%">Produtos:</p>
                  <div style="opacity: 60%" class="ml-3">
                    <template
                      v-for="produtos in produto.produtos"
                      :key="produtos"
                    >
                      <div class="mt-2">
                        <div v-if="!produtos.tamSelecionado">
                          {{ produtos.nome + " x " + produtos.quantidade }}
                        </div>
                        <div v-if="produtos.tamSelecionado">
                          {{
                            produtos.nome +
                            " " +
                            produtos.tamSelecionado.descricao +
                            " x " +
                            produtos.quantidade
                          }}
                        </div>
                        <template v-if="produtos.saborSelecionado">
                          <span>Sabor:</span>
                          <template
                            v-for="(sabor, index) in produtos.saborSelecionado"
                            :key="sabor"
                          >
                            <span
                              v-if="
                                index + 1 == produtos.saborSelecionado.length
                              "
                              >{{ sabor.descricao }}</span
                            >
                            <span v-else>{{ sabor.descricao + "," }}</span>
                          </template>
                        </template>
                      </div>
                    </template>
                  </div>
                  <v-card-title class="d-flex justify-end mt-5">
                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      v-if="produto.quantidade >= 2"
                      @click="
                        (produto.quantidade = produto.quantidade - 1),
                          (reveal = true),
                          this.enviaPreco()
                      "
                    >
                      <faT
                        style="height: 20px"
                        :color="dadosEmpresa.corBase"
                        icon="circle-minus"
                      />
                    </v-btn>
                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      v-if="
                        produto.quantidade == 1 &&
                        this.mutableCarrinho.length == 1
                      "
                      @click="
                        (reveal = true),
                          (produto.quantidade = 0),
                          (this.mutableCarrinho = []),
                          this.enviaPreco(),
                          this.$router.push('/')
                      "
                    >
                      <faT
                        style="height: 20px"
                        :color="dadosEmpresa.corBase"
                        icon="circle-minus"
                      />
                    </v-btn>
                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      v-if="
                        produto.quantidade == 1 &&
                        this.mutableCarrinho.length > 1
                      "
                      @click="
                        (reveal = true),
                          (produto.quantidade = 0),
                          (index = mutableCarrinho.indexOf(produto)),
                          mutableCarrinho.splice(index, 1),
                          this.enviaPreco()
                      "
                    >
                      <faT
                        style="height: 20px"
                        :color="dadosEmpresa.corBase"
                        icon="circle-minus"
                      />
                    </v-btn>
                    <v-card-subtitle class="mt-1">
                      <p
                        v-if="produto.quantidade > 0"
                        :style="'font-size:14px; color:' + dadosEmpresa.corBase"
                      >
                        {{ produto.quantidade }} x
                      </p>
                    </v-card-subtitle>

                    <v-btn
                      v-if="produto.quantidade >= 1"
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      @click="
                        (produto.quantidade += 1),
                          (reveal = true),
                          this.enviaPreco()
                      "
                    >
                      <faT
                        style="height: 20px"
                        :color="dadosEmpresa.corBase"
                        icon="circle-plus"
                      />
                    </v-btn>
                  </v-card-title>
                </v-col>
              </v-row>
            </v-card>
          </div>
          <!-- Tamanho Unico -->
          <div
            v-if="produto.quantidade >= 1 && produto.tamanhoUnic == true"
            class="d-flex align-center flex-column mb-10 text-left"
          >
            <v-card class="mt-2 pb-3" width="100%">
              <v-row align="center">
                <v-col cols="4">
                  <div class="ml-3 mt-2 mb-2 rounded">
                    <img
                      :style="
                        'width: 100px; height: 125px; border-radius: 8px; border: 0.5px solid' +
                        dadosEmpresa.corBase +
                        '; object-fit: cover;'
                      "
                      :src="produto.img_url"
                    />
                  </div>
                </v-col>
                <v-col cols="8">
                  <v-card-title class="pa-0">{{ produto.nome }}</v-card-title>
                  <p class="pa-0" style="opacity: 60%">
                    {{ produto.descricao }}
                  </p>
                  <div
                    :style="
                      'border: 1px solid white; color:' +
                      dadosEmpresa.corBase +
                      '; border-radius: 5px;'
                    "
                    v-if="
                      produto.tempoExtra &&
                      produto.tempoExtra.ativo == true &&
                      this.selecionado == 'Encomendas'
                    "
                  >
                    Este produto necessita de no mínimo
                    {{ produto.tempoExtra.dias }} para ser entregue
                  </div>

                  <v-card-title class="pa-0">
                    <p
                      :style="
                        'font-size:14px; color:' +
                        dadosEmpresa.corBase +
                        '; z-index: 999'
                      "
                    >
                      R${{ produto.valor }}
                    </p>
                    <v-col cols="10" v-if="produto.saborComp">
                      <p style="opacity: 60%; font-size: 15px">
                        Maximo de sabores:
                        {{
                          produto.limiteSaborUnic ? produto.limiteSaborUnic : 1
                        }}
                      </p>
                      <v-form :ref="`form${index}`">
                        <v-select
                          multiple
                          v-model="produto.saborSelecionado"
                          label="Sabores"
                          :items="produto.valorSaborComposto"
                          :item-disabled="(item) => item.disabled"
                          :item-title="
                            (item) => item.descricao + ' - R$' + item.valor
                          "
                          :item-value="(item) => item"
                          variant="underlined"
                          :color="dadosEmpresa.corBase"
                          :rules="[
                            (val) =>
                              val.length <=
                                (produto.limiteSaborUnic
                                  ? produto.limiteSaborUnic
                                  : 1) ||
                              'Selecione sabores de acordo com o limite',
                          ]"
                        >
                          <template v-slot:item="{ item, props }">
                            <v-list-item
                              :disabled="
                                produto.saborSelecionado != null &&
                                !produto.saborSelecionado.find(
                                  (val) =>
                                    val.descricao == item.value.descricao,
                                ) &&
                                produto.saborSelecionado.length ==
                                  (produto.limiteSaborUnic
                                    ? produto.limiteSaborUnic
                                    : 1)
                              "
                              v-bind="props"
                              :key="item.value.descricao"
                              :value="item.value"
                              :title="
                                item.value.descricao +
                                ' - R$' +
                                item.value.valor
                              "
                            >
                            </v-list-item>
                          </template>
                        </v-select>
                      </v-form>
                    </v-col>
                  </v-card-title>
                  <v-card-title class="pa-0">
                    <v-row class="d-flex ml-1">
                      <v-col v-if="produto.adicionais == 'true'" cols="8">
                        <v-select
                          multiple
                          @update:modelValue="enviaPreco()"
                          v-model="produto.adicionaisSelecionados"
                          label="Adicionais"
                          :items="produto.valorAdicionais"
                          :item-title="
                            (item) => item.descricao + ' - R$' + item.valor
                          "
                          :item-value="(item) => item"
                          variant="underlined"
                          :color="dadosEmpresa.corBase"
                        >
                          <template v-slot:item="{ item, props }">
                            <v-list-item
                              v-bind="props"
                              :key="item.value.descricao"
                              :value="item.value"
                              :title="
                                item.value.descricao +
                                ' - R$' +
                                item.value.valor
                              "
                            >
                            </v-list-item>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col
                        cols="1"
                        class="mt-4 mr-14"
                        v-if="produto.adicionais == 'true' || produto.saborComp"
                      >
                        <v-btn
                          v-if="isMobile()"
                          @click="duplicarProduto(produto, index)"
                          rounded
                          elevation="0"
                        >
                          <v-icon :color="dadosEmpresa.corBase"
                            >mdi-content-duplicate</v-icon
                          >
                        </v-btn>
                        <v-tooltip
                          v-if="!isMobile()"
                          location="top"
                          text="Duplicar"
                        >
                          <template v-slot:activator="{ props }">
                            <v-btn
                              @click="duplicarProduto(produto, index)"
                              v-bind="props"
                              rounded
                              elevation="0"
                            >
                              <v-icon :color="dadosEmpresa.corBase"
                                >mdi-content-duplicate</v-icon
                              >
                            </v-btn>
                          </template>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-title class="d-flex justify-end mt-5">
                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      v-if="produto.quantidade >= 2"
                      @click="
                        (produto.quantidade = produto.quantidade - 1),
                          (reveal = true),
                          this.enviaPreco()
                      "
                    >
                      <faT
                        style="height: 20px"
                        :color="dadosEmpresa.corBase"
                        icon="circle-minus"
                      />
                    </v-btn>
                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      v-if="
                        produto.quantidade == 1 &&
                        this.mutableCarrinho.length == 1
                      "
                      @click="
                        (reveal = true),
                          (produto.quantidade = 0),
                          (this.mutableCarrinho = []),
                          this.enviaPreco(),
                          this.$router.push('/')
                      "
                    >
                      <faT
                        style="height: 20px"
                        :color="dadosEmpresa.corBase"
                        icon="circle-minus"
                      />
                    </v-btn>
                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      v-if="
                        produto.quantidade == 1 &&
                        this.mutableCarrinho.length > 1
                      "
                      @click="
                        (reveal = true),
                          (produto.quantidade = 0),
                          (index = mutableCarrinho.indexOf(produto)),
                          mutableCarrinho.splice(index, 1),
                          this.enviaPreco()
                      "
                    >
                      <faT
                        style="height: 20px"
                        :color="dadosEmpresa.corBase"
                        icon="circle-minus"
                      />
                    </v-btn>
                    <v-card-subtitle class="mt-1">
                      <p
                        v-if="produto.quantidade > 0"
                        :style="
                          'font-size:14px; color: ' + dadosEmpresa.corBase
                        "
                      >
                        {{ produto.quantidade }} x
                      </p>
                    </v-card-subtitle>

                    <v-btn
                      v-if="produto.quantidade >= 1"
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      @click="
                        (produto.quantidade += 1),
                          (reveal = true),
                          this.enviaPreco()
                      "
                    >
                      <faT
                        style="height: 20px"
                        :color="dadosEmpresa.corBase"
                        icon="circle-plus"
                      />
                    </v-btn>
                  </v-card-title>
                </v-col>
              </v-row>
            </v-card>
          </div>
          <!-- Tamanho Composto -->
          <div
            class="d-flex align-center flex-column mb-10"
            v-if="produto.tamanhoComp == true && produto.quantidade >= 1"
          >
            <v-card class="mt-2 pb-3" width="100%">
              <v-row align="center">
                <v-col cols="4">
                  <div class="ml-3 mt-2 mb-2 rounded">
                    <img
                      :style="
                        'width: 100px; height: 125px; border-radius: 8px; border: 0.5px solid' +
                        dadosEmpresa.corBase +
                        '; object-fit: cover;'
                      "
                      :src="produto.img_url"
                    />
                  </div>
                </v-col>
                <v-col cols="8">
                  <v-card-title class="pa-0">{{ produto.nome }}</v-card-title>
                  <p class="pa-0" style="opacity: 60%">
                    {{ produto.descricao }}
                  </p>
                  <div
                    :style="
                      'border: 1px solid white; color:' +
                      dadosEmpresa.corBase +
                      '; border-radius: 5px;'
                    "
                    v-if="
                      produto.tempoExtra &&
                      produto.tempoExtra.ativo == true &&
                      this.selecionado == 'Encomendas'
                    "
                  >
                    Este produto necessita de no mínimo
                    {{ produto.tempoExtra.dias }} para ser entregue
                  </div>

                  <v-card-title class="pa-0">
                    <v-row>
                      <v-col cols="8">
                        <v-select
                          required
                          @update:modelValue="
                            enviaPreco(), (produto.saborSelecionado = [])
                          "
                          v-model="produto.tamSelecionado"
                          label="Tamanhos"
                          :items="produto.valorTamComposto"
                          :item-title="
                            (item) => item.descricao + ' - R$' + item.valor
                          "
                          :item-value="(item) => item"
                          variant="underlined"
                          :color="dadosEmpresa.corBase"
                        />
                      </v-col>
                      <v-col cols="8" v-if="produto.saborComp">
                        <p style="opacity: 60%; font-size: 15px">
                          Maximo de sabores:
                          {{
                            produto.tamSelecionado.sabores
                              ? produto.tamSelecionado.sabores
                              : 1
                          }}
                        </p>

                        <v-form :ref="`form${index}`">
                          <v-select
                            multiple
                            @update:modelValue="enviaPreco()"
                            v-model="produto.saborSelecionado"
                            label="Sabores"
                            :items="produto.valorSaborComposto"
                            :item-disabled="(item) => item.disabled"
                            :item-title="
                              (item) => item.descricao + ' - R$' + item.valor
                            "
                            :item-value="(item) => item"
                            variant="underlined"
                            :color="dadosEmpresa.corBase"
                            :rules="[
                              (val) =>
                                val.length <=
                                  (produto.tamSelecionado.sabores
                                    ? produto.tamSelecionado.sabores
                                    : 1) ||
                                'Selecione sabores de acordo com o limite',
                            ]"
                          >
                            <template v-slot:item="{ item, props }">
                              <v-list-item
                                :disabled="
                                  produto.saborSelecionado != null &&
                                  !produto.saborSelecionado.find(
                                    (val) =>
                                      val.descricao == item.value.descricao,
                                  ) &&
                                  produto.saborSelecionado.length ==
                                    (produto.tamSelecionado.sabores
                                      ? produto.tamSelecionado.sabores
                                      : 1)
                                "
                                v-bind="props"
                                :key="item.value.descricao"
                                :value="item.value"
                                :title="
                                  item.value.descricao +
                                  ' - R$' +
                                  item.value.valor
                                "
                              >
                              </v-list-item>
                            </template>
                          </v-select>
                        </v-form>
                      </v-col>
                      <v-col v-if="produto.adicionais == 'true'" cols="8">
                        <v-select
                          multiple
                          @update:modelValue="enviaPreco()"
                          v-model="produto.adicionaisSelecionados"
                          label="Adicionais"
                          :items="produto.valorAdicionais"
                          :item-title="
                            (item) => item.descricao + ' - R$' + item.valor
                          "
                          :item-value="(item) => item"
                          variant="underlined"
                          :color="dadosEmpresa.corBase"
                        >
                          <template v-slot:item="{ item, props }">
                            <v-list-item
                              v-bind="props"
                              :key="item.value.descricao"
                              :value="item.value"
                              :title="
                                item.value.descricao +
                                ' - R$' +
                                item.value.valor
                              "
                            >
                            </v-list-item>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="2" class="mt-4">
                        <v-btn
                          v-if="isMobile()"
                          @click="duplicarProduto(produto, index)"
                          rounded
                          elevation="0"
                        >
                          <v-icon :color="dadosEmpresa.corBase"
                            >mdi-content-duplicate</v-icon
                          >
                        </v-btn>
                        <v-tooltip
                          v-if="!isMobile()"
                          location="top"
                          text="Duplicar"
                        >
                          <template v-slot:activator="{ props }">
                            <v-btn
                              @click="duplicarProduto(produto, index)"
                              v-bind="props"
                              rounded
                              elevation="0"
                            >
                              <v-icon :color="dadosEmpresa.corBase"
                                >mdi-content-duplicate</v-icon
                              >
                            </v-btn>
                          </template>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-title class="d-flex justify-end">
                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      v-if="produto.quantidade >= 2"
                      @click="
                        (produto.quantidade = produto.quantidade - 1),
                          (reveal = true),
                          this.enviaPreco()
                      "
                    >
                      <faT
                        style="height: 20px"
                        :color="dadosEmpresa.corBase"
                        icon="circle-minus"
                      />
                    </v-btn>
                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      v-if="
                        produto.quantidade == 1 &&
                        this.mutableCarrinho.length == 1
                      "
                      @click="
                        (reveal = true),
                          (produto.quantidade = 0),
                          (this.mutableCarrinho = []),
                          this.enviaPreco(),
                          this.$router.push('/')
                      "
                    >
                      <faT
                        style="height: 20px"
                        :color="dadosEmpresa.corBase"
                        icon="circle-minus"
                      />
                    </v-btn>
                    <v-btn
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      v-if="
                        produto.quantidade == 1 &&
                        this.mutableCarrinho.length > 1
                      "
                      @click="
                        (reveal = true),
                          (produto.quantidade = 0),
                          (index = mutableCarrinho.indexOf(produto)),
                          mutableCarrinho.splice(index, 1),
                          this.enviaPreco()
                      "
                    >
                      <faT
                        style="height: 20px"
                        :color="dadosEmpresa.corBase"
                        icon="circle-minus"
                      />
                    </v-btn>
                    <v-card-subtitle class="mt-1">
                      <p
                        v-if="produto.quantidade > 0"
                        :style="
                          'font-size:14px; color: ' + dadosEmpresa.corBase
                        "
                      >
                        {{ produto.quantidade }} x
                      </p>
                    </v-card-subtitle>
                    <v-btn
                      id="valor"
                      v-if="produto.quantidade < 1"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      @click="
                        (produto.quantidade += 1),
                          (reveal = true),
                          mutableCarrinho.push(produto),
                          this.enviaPreco()
                      "
                    >
                      <faT
                        style="height: 20px"
                        :color="dadosEmpresa.corBase"
                        icon="circle-plus"
                      />
                    </v-btn>

                    <v-btn
                      v-if="produto.quantidade >= 1"
                      id="valor"
                      variant="text"
                      :color="dadosEmpresa.corBase"
                      @click="
                        (produto.quantidade += 1),
                          (reveal = true),
                          this.enviaPreco()
                      "
                    >
                      <faT
                        style="height: 20px"
                        :color="dadosEmpresa.corBase"
                        icon="circle-plus"
                      />
                    </v-btn>
                  </v-card-title>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </template>
        <v-form ref="form">
          <template v-if="this.logado.data.nome != ''">
            <v-checkbox-btn
              v-model="usaDados"
              :value="true"
              color="green"
              label="Usar dados do Usuario"
            ></v-checkbox-btn>
            <v-checkbox-btn
              v-model="usaDados"
              :value="false"
              :color="dadosEmpresa.corBase"
              label="Usar outros dados"
            ></v-checkbox-btn>

            <v-card v-if="usaDados">
              <v-col class="text-left">
                <p>
                  Nome: {{ this.logado.data.nome }}
                  {{ this.logado.data.sobrenome }}
                </p>
                <p>Celular: {{ this.logado.data.telefone }}</p>
                <p>CPF: {{ this.logado.data.cpf }}</p>
                <p>Endereco: {{ this.logado.data.endereco }}, {{ this.logado.data.numero ? this.logado.data.numero : '' }} {{ this.logado.data.complemento ? ', ' + this.logado.data.complemento : ''}}</p>
                <p>Bairro: {{ this.logado.data.bairro.nome }}</p>
                <p>Cidade: {{ this.logado.data.cidade }}</p>
              </v-col>
            </v-card>
          </template>
          <v-row class="align-center flex-column mb-1">
            <v-col cols="11" class="mx-auto">
              <v-text-field
                v-model="cliente.nome"
                :color="dadosEmpresa.corBase"
                label="Nome"
                variant="underlined"
                required
                maxlength="60"
                v-if="
                  this.logado.data.nome == '' ||
                  (this.logado.data.nome != '' && !usaDados)
                "
                :rules="[
                  (val) =>
                    (RegExp(
                      '^[A-Za-z0-9-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ ]*$',
                    ).test(val) &&
                      !RegExp('[ ]{2,}').test(val)) ||
                    'Nome Inválido',
                  (val) => val != '' || 'Insira seu nome',
                  (val) => val != null || 'Insira seu nome',
                  (val) => val != undefined || 'Insira seu nome',
                  (val) => val.length != 1 || 'Insira seu nome',
                ]"
              >
              </v-text-field>
              <v-text-field
                v-model="cliente.cpf"
                :color="dadosEmpresa.corBase"
                label="CPF (somente numeros)"
                variant="underlined"
                v-if="
                  this.logado.data.nome == '' ||
                  (this.logado.data.nome != '' && !usaDados)
                "
                pattern="[0-9]*"
                counter
                placeholder="999.999.999-99"
                maxlength="11"
                minlength="11"
                required
                :rules="[
                  (val) => val != '' || 'Cpf Inválido',
                  (val) => val != null || 'Cpf Inválido',
                  (val) =>
                    val != null
                      ? (val.length != 14 && this.validaCpf()) || 'Cpf Inválido'
                      : '',
                ]"
              >
              </v-text-field>
              <v-text-field
                v-model="cliente.telefone"
                label="Celular (somente numeros)"
                variant="underlined"
                v-if="
                  this.logado.data.nome == '' ||
                  (this.logado.data.nome != '' && !usaDados)
                "
                :color="dadosEmpresa.corBase"
                counter
                placeholder="(99) 9999-99999"
                maxlength="15"
                minlength="14"
                required
                :rules="[
                  (val) => val != null || 'Digite seu número de telefone',
                  (val) => val != '' || 'Digite seu número de telefone',
                  (val) => val != undefined || 'Digite seu número de telefone',
                  (val) => val.length >= 14 || 'Número inválido',
                ]"
              ></v-text-field>
              <v-col class="text-left mb-n8">
                <span
                  style="color: grey; padding-top: 16px; margin-bottom: 16px"
                  >Precisa tele?</span
                >
                <div class="d-flex justify-space-between">
                  <v-checkbox-btn
                    :error-messages="this.errorCheckboxTele"
                    @click="this.enviaPreco()"
                    v-model="precisaTele"
                    label="Sim"
                    value="true"
                    class="left"
                    color="green"
                  >
                  </v-checkbox-btn>
                  <v-checkbox-btn
                    v-model="precisaTele"
                    label="Não"
                    @click="this.enviaPreco()"
                    value="false"
                    class="right"
                    :color="dadosEmpresa.corBase"
                  >
                  </v-checkbox-btn>
                </div>
              </v-col>
              <v-col class="text-left">
                <span
                  class="ml-n3"
                  style="color: grey; padding-top: 16px; margin-bottom: 16px"
                  v-if="precisaTele == 'true'"
                >
                  Valor Tele: {{ this.valorTele }}</span
                >
              </v-col>
              <v-text-field
                v-if="precisaTele == 'true' && !this.usaDados"
                style="width: 100%"
                clearable
                clear-icon="mdi-close"
                :label="'Cep (somente números)'"
                v-model="cliente.cep"
                required
                :rules="[
                  (val) => val != null || 'Digite seu cep',
                  (val) => val != '' || 'Digite seu cep',
                  (val) => val != undefined || 'Digite seu cep',
                  (val) => val.length >= 9 || 'Cep inválido',
                ]"
                variant="underlined"
                color="red"
              >
              </v-text-field>
              <v-row>
                <v-col cols="8">
                  <v-text-field
                    v-if="precisaTele == 'true' && !this.usaDados"
                    v-model="cliente.endereco"
                    label="Endereco"
                    :color="dadosEmpresa.corBase"
                    variant="underlined"
                    required
                    :rules="[
                      (val) => val != '' || 'Insira seu endereco',
                      (val) => val != null || 'Insira seu endereco',
                      (val) => val != undefined || 'Insira seu endereco',
                    ]"
                  ></v-text-field>
                </v-col>
                <v-col  cols="4">
                  <v-text-field
                  v-if="precisaTele == 'true' && !this.usaDados"
                  clearable
                  clear-icon="mdi-close"
                  v-model="cliente.numero"
                  :color="dadosEmpresa.corBase"
                  label="Número"
                  required
                  :rules="[
                    (val) => val != '' || 'Insira o número',
                    (val) => val != null || 'Insira o número',
                    (val) => val != undefined || 'Insira o número',
                    (val) => /^[a-zA-Z0-9 .]*$/.test(val) || 'Número Inválido',
                    !RegExp('[ ]{2,}').test(val) || 'Número Inválido',
                    (val) => val.length <= 8 || 'Número inválido',
                  ]"
                  variant="underlined">
                </v-text-field>
                </v-col>
              </v-row>
              <v-text-field
                  v-if="precisaTele == 'true' && !this.usaDados"
                  clearable
                  clear-icon="mdi-close"
                  v-model="cliente.complemento"
                  :color="dadosEmpresa.corBase"
                  label="Complemento (Se não necessitar, deixar vazio)"
                  required
                  :rules="[
                    (val) => val != null || 'Insira o complemento',
                    (val) => val != undefined || 'Insira o complemento',
                    (val) => /^[a-zA-Z0-9 .]*$/.test(val) || 'Complemento Inválido',
                    !RegExp('[ ]{2,}').test(val) || 'Complemento Inválido',
                  ]"
                  variant="underlined">
                </v-text-field>
              <v-autocomplete
                v-if="precisaTele == 'true' && !this.usaDados"
                v-model="cliente.bairro"
                label="Bairro"
                :items="bairros"
                :item-title="(item) => item.nome"
                :item-value="(item) => item"
                :color="dadosEmpresa.corBase"
                variant="underlined"
                clearable
                density="comfortable"
                required
                max-height="50px"
                :rules="[
                  (val) => val != null || 'Selecione um Bairro',
                  (val) => val != '' || 'Selecione um Bairro',
                ]"
              ></v-autocomplete>
              <v-textarea
                v-model="pedidos.observacao"
                label="Observações"
                :color="dadosEmpresa.corBase"
                variant="underlined"
                maxlength="200"
                :rules="[
                  (val) =>
                    (RegExp(
                      '^[A-Za-z0-9-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ,.()\n ]*$',
                    ).test(val) &&
                      !RegExp('[ ]{2,}').test(val)) ||
                    'Obervação Inválida, verifique espaçamento e caracteres',
                ]"
              >
                >
              </v-textarea>
              <div
                v-if="
                  this.dadosEmpresa != undefined &&
                  this.selecionado == 'Encomendas'
                "
                class="text-left"
                style="color: grey; padding-top: 16px; margin-bottom: 16px"
              >
                <span>Data de Entrega</span>
                <input
                  type="date"
                  v-model="pedidos.dataEntrega"
                  class="px-1"
                  style="
                    border: 0.5px solid grey;
                    border-radius: 5px;
                    width: 100%;
                    height: 56px;
                    color: grey;
                  "
                />
                <div style="padding-top: 32px; margin-bottom: 16px">
                  <span>Hora da Entrega</span>
                  <input
                    v-model="pedidos.horaEntrega"
                    style="
                      border: 0.5px solid grey;
                      border-radius: 5px;
                      width: 100%;
                      height: 56px;
                      color: grey;
                      font-size: 18px;
                    "
                    type="time"
                    id="appt"
                    name="appt"
                  />
                  <div class="text-center" v-if="this.errorHorario != ''">
                    <span class="text-error text-center" style="font-size: 14px"
                      >{{ this.errorHorario }}
                      <span
                        @click="dialogHorario = true"
                        style="cursor: pointer"
                        class="font-weight-bold"
                      >
                        Clique para visualizar os horários.</span
                      ></span
                    >
                  </div>
                </div>
              </div>
              <v-select
                v-if="this.dadosEmpresa.sitef"
                v-model="ambientePgto"
                :menu-props="{ overflow: 'hidden' }"
                :items="ambientesPgto"
                :color="dadosEmpresa.corBase"
                variant="underlined"
                label="Onde pagar?"
                required
                :rules="[
                  (val) => val != '' || 'Escolha o ambiente de pagamento',
                  (val) => val != null || 'Escolha o ambiente de pagamento',
                  (val) =>
                    val != undefined || 'Escolha o ambiente de pagamento',
                ]"
              ></v-select>
              <v-select
                id="metodoPgto"
                v-model="metodoPgto"
                :menu-props="{ overflow: 'hidden' }"
                :items="mutableMetodosPgto"
                :item-value="(item) => item.nome"
                :item-title="(item) => item.nome"
                :color="dadosEmpresa.corBase"
                variant="underlined"
                label="Método  de Pagamento"
                required
                :rules="[
                  (val) => val != '' || 'Escolha o metódo de pagamento]',
                  (val) => val != null || 'Escolha o metódo de pagamento',
                  (val) => val != undefined || 'Escolha o metódo de pagamento',
                ]"
              ></v-select>

              <v-col v-if="metodoPgto == 'Dinheiro'" class="text-left">
                <span
                  class="ml-n3"
                  style="color: grey; padding-top: 16px; margin-bottom: 16px"
                  >Precisa troco?</span
                >
                <div class="d-flex justify-space-between">
                  <v-checkbox
                    :error-messages="this.errorCheckboxTroco"
                    v-model="precisaTroco"
                    label="Sim"
                    value="true"
                    class="left"
                    color="green"
                  >
                  </v-checkbox>
                  <v-checkbox
                    v-model="precisaTroco"
                    label="Não"
                    value="false"
                    class="right"
                    :color="dadosEmpresa.corBase"
                  >
                  </v-checkbox>
                </div>
              </v-col>

              <v-text-field
                v-if="metodoPgto == 'Dinheiro' && precisaTroco == 'true'"
                type="text"
                name="decimal"
                v-model="pedidos.valorTroco"
                variant="underlined"
                label="Troco para (R$)"
                color="red"
                clearable
                clear-icon="mdi-close"
                required
                maxlength="6"
                :rules="[
                  (val) =>
                    RegExp('^[0-9,]*$').test(val) || 'Valor precisa ser válido',
                  (val) =>
                    parseFloat(val.replace(',', '.')) >= this.precoTotal ||
                    'Troco necessita ser maior ou igual ao valor total',
                ]"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-dialog v-model="dialog">
          <v-row>
            <v-col cols="11" md="4" class="mx-auto">
              <v-card
                style="width: 100%; overflow-y: auto; max-height: 80vh"
                class="mx-auto"
              >
                <v-row style="width: 100">
                  <v-col cols="12">
                    <v-card-title>
                      <h2>Confirme seu pedido</h2>
                    </v-card-title>
                    <v-card-subtitle>
                      Cliente: {{ cliente.nome }}
                    </v-card-subtitle>
                    <v-card-text>
                      <p>Número: {{ cliente.telefone }}</p>
                      <p v-if="pedidos.dataEntrega">
                        Data Entrega:
                        {{ pedidos.dataEntrega.split("-").reverse().join("/") }}
                      </p>
                      <p v-if="pedidos.horaEntrega">
                        Hora Entrega: {{ pedidos.horaEntrega }}
                      </p>

                      <p v-if="precisaTele == 'true'">
                        Endereco: {{ cliente.endereco }}, {{ this.cliente.numero ? this.cliente.numero + ', ' + this.cliente.bairro.nome + this.cliente.complemento != '' ? ' - ' + this.cliente.complemento : '' : '' }}
                      </p>
                    </v-card-text>
                    <v-card-text class="mb-n5">
                      <h2>Produtos:</h2>
                    </v-card-text>
                    <v-card-text
                      v-for="(produto, index) in mutableCarrinho"
                      :key="produto"
                    >
                      <div class="d-flex mt-4">
                        <div class="justify-content-left" style="width: 100%">
                          <strong
                            >{{ index + 1 }} --
                            {{
                              produto.nomeTamanho
                                ? produto.nomeTamanho
                                : produto.nome
                            }}</strong
                          >
                        </div>
                      </div>
                      <div v-if="produto.produtos">
                        <p style="opacity: 60%">Produtos:</p>
                        <div style="opacity: 60%" class="ml-3">
                          <template
                            v-for="produtos in produto.produtos"
                            :key="produtos"
                          >
                            <div class="mt-2">
                              <div v-if="!produtos.tamSelecionado">
                                {{
                                  produtos.nome + " x " + produtos.quantidade
                                }}
                              </div>
                              <div v-if="produtos.tamSelecionado">
                                {{
                                  produtos.nome +
                                  " " +
                                  produtos.tamSelecionado.descricao +
                                  " x " +
                                  produtos.quantidade
                                }}
                              </div>
                              <template v-if="produtos.saborSelecionado">
                                <span>Sabor:</span>
                                <template
                                  v-for="(
                                    sabor, index
                                  ) in produtos.saborSelecionado"
                                  :key="sabor"
                                >
                                  <span
                                    v-if="
                                      index + 1 ==
                                      produtos.saborSelecionado.length
                                    "
                                    >{{ sabor.descricao }}</span
                                  >
                                  <span v-else>{{
                                    sabor.descricao + ","
                                  }}</span>
                                </template>
                              </template>
                            </div>
                          </template>
                        </div>
                      </div>

                      <div class="d-flex">
                        <div
                          class="justify-content-left ml-2"
                          style="width: 80%"
                        >
                          <p>
                            {{ produto.quantidade }} x
                            {{
                              parseFloat(produto.valor)
                                .toFixed(2)
                                .replace(".", ",")
                            }}
                          </p>
                        </div>
                        <div
                          class="justify-content-right text-left"
                          style="width: 20%"
                        >
                          <p>
                            {{
                              (parseFloat(produto.valor) * produto.quantidade)
                                .toFixed(2)
                                .replace(".", ",")
                            }}
                          </p>
                        </div>
                      </div>
                      <div v-if="produto.saborComp">
                        <div class="d-flex">
                          <div class="justify-content-left" style="width: 100%">
                            <strong>Sabores: </strong>
                          </div>
                        </div>
                        <div class="d-flex ml-2">
                          <div class="justify-content-left" style="width: 80%">
                            <p>{{ produto.saboresDesc }}</p>
                          </div>
                          <div
                            class="justify-content-right text-left"
                            style="width: 20%"
                          >
                            <p>
                              {{
                                parseFloat(produto.valorSaboresDesc)
                                  .toFixed(2)
                                  .replace(".", ",")
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div v-if="produto.adicionaisDesc">
                        <div class="d-flex">
                          <div class="justify-content-left" style="width: 100%">
                            <strong>Adicionais: </strong>
                          </div>
                        </div>
                        <div class="d-flex ml-2">
                          <div class="justify-content-left" style="width: 80%">
                            <p>{{ produto.adicionaisDesc }}</p>
                          </div>
                          <div
                            class="justify-content-right text-left"
                            style="width: 20%"
                          >
                            <p>
                              {{
                                parseFloat(produto.valorAdicionaisDesc)
                                  .toFixed(2)
                                  .replace(".", ",")
                              }}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="parseInt(index) == mutableCarrinho.length - 1"
                        class="mt-4"
                      >
                        <div class="d-flex" v-if="this.precisaTele == 'true'">
                          <div class="justify-content-left" style="width: 80%">
                            <p>Valor Tele</p>
                          </div>
                          <div
                            class="justify-content-right text-left"
                            style="width: 20%"
                          >
                            <span>{{
                              parseFloat(this.valorTele.replace(",", "."))
                                .toFixed(2)
                                .replace(".", ",")
                            }}</span>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="justify-content-left" style="width: 80%">
                            <p>Valor total</p>
                          </div>
                          <div
                            class="justify-content-right text-left"
                            style="width: 20%"
                          >
                            <strong>{{
                              parseFloat(precoTotal)
                                .toFixed(2)
                                .replace(".", ",")
                            }}</strong>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                    <v-card-text>
                      <p v-if="pedidos.observacao">
                        Observação: <strong>{{ pedidos.observacao }}</strong>
                      </p>
                      <p>
                        Forma de Pagamento: <strong>{{ metodoPgto }}</strong>
                      </p>
                      <p>
                        Modo de entrega:
                        <strong>{{
                          this.precisaTele == "true" ? "Tele" : "Retirada"
                        }}</strong>
                      </p>
                      <p v-if="pedidos.valorTroco">
                        Valor Troco:
                        <strong>{{
                          parseFloat(pedidos.valorTroco)
                            .toFixed(2)
                            .replace(".", ",")
                        }}</strong>
                      </p>
                    </v-card-text>
                    <v-col class="d-flex justify-space-around" cols="12">
                      <v-btn
                        icon="mdi-check"
                        label="Aceitar"
                        color="green"
                        @click="
                          validacoes('aceito'),
                            this.dadosEmpresa.sitef == true &&
                            this.ambientePgto != 'Pagar na entrega/retirada' ||
                            metodoPgto.toLowerCase().match('pix') && this.ambientePgto == 'Pagar na entrega/retirada' && 
                            dadosEmpresa.chavePix
                              ? ''
                              : (dialogWhats = true)
                        "
                      ></v-btn>
                      <v-btn
                        @click="dialog = false, this.cliente.endereco = this.cliente.endereco.replace(`, ${this.cliente.bairro.nome}`, '')"
                        icon="mdi-close"
                        label="Recusar"
                        color="red"
                      >
                    </v-btn>
                    </v-col>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-dialog>
        <v-dialog v-model="dialogHorario">
          <v-col cols="12" md="4" class="mx-auto">
            <v-card class="ml-n8">
              <v-card-text>
                <p v-if="segundaabre != ''">Segunda: {{ segundaabre }}</p>
                <p v-else>Segunda: Fechado</p>

                <p v-if="tercaabre != ''">Terca: {{ tercaabre }}</p>
                <p v-else>Terca: Fechado</p>

                <p v-if="quartaabre != ''">Quarta: {{ quartaabre }}</p>
                <p v-else>Quarta: Fechado</p>

                <p v-if="quintaabre != ''">Quinta: {{ quintaabre }}</p>
                <p v-else>Quinta: Fechado</p>

                <p v-if="sextaabre != ''">Sexta: {{ sextaabre }}</p>
                <p v-else>Sexta: Fechado</p>

                <p v-if="sabadoabre != ''">Sabado: {{ sabadoabre }}</p>
                <p v-else>Sabado: Fechado</p>

                <p v-if="domingoabre != ''">Domingo: {{ this.domingoabre }}</p>
                <p v-else>Domingo: Fechado</p>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  :color="dadosEmpresa.corBase"
                  block
                  @click="dialogHorario = false"
                  >Fechar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-dialog>
        <v-dialog v-model="dialogCartao" persistent style="z-index: 1000">
          <v-form ref="formCartao" style="font-size: 10px">
            <v-row class="d-flex justify-center">
              <v-col md="4" cols="12" class="d-flex justify-end">
                <VuePaycard :value-fields="valueFields"></VuePaycard>
              </v-col>
              <v-col md="5" cols="12">
                <v-card class="pa-5" style="width: 100%">
                  <span v-if="this.mdAndUp" class="text-grey ml-4"
                    >Número do cartao:</span
                  >
                  <v-row class="d-flex ml-1">
                    <template v-if="this.mdAndUp">
                      <v-col
                        v-for="(part, index) in cardParts"
                        :key="index"
                        cols="2"
                      >
                        <v-text-field
                          variant="underlined"
                          :color="this.dadosEmpresa.corBase"
                          v-model="cardParts[index]"
                          maxlength="4"
                          :ref="`part${index}`"
                          @keydown="handleKeydownCard(index, $event)"
                          @input="handleInputCard(index)"
                        ></v-text-field>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col cols="12">
                        <v-text-field
                          variant="underlined"
                          name="cc-number"
                          autocomplete="cc-number"
                          label="Número do cartão"
                          :color="this.dadosEmpresa.corBase"
                          v-model="valueFields.cardNumber"
                          :value="formattedCardNumber"
                          maxlength="20"
                          counter="20"
                          :rules="[
                            (v) => !!v || 'Número do Cartão é obrigatório',
                            (v) =>
                              /^\d{16}$/.test(v.replace(/\s/g, '')) ||
                              'Número do Cartão inválido',
                          ]"
                          @input="onCardNumberInput"
                        ></v-text-field>
                      </v-col>
                    </template>

                    <v-col
                      cols="12"
                      md="4"
                      :class="this.mdAndUp ? '' : 'mt-n5'"
                    >
                      <v-text-field
                        variant="underlined"
                        name="cc-name"
                        autocomplete="cc-name"
                        :color="this.dadosEmpresa.corBase"
                        v-model="valueFields.cardName"
                        label="Nome"
                        :rules="[
                          (val) =>
                            (RegExp(
                              '^[A-Za-z0-9-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ,.()\n ]*$',
                            ).test(val) &&
                              !RegExp('[ ]{2,}').test(val)) ||
                            'Nome Inválido, verifique espaçamento e caracteres',
                          (val) => val != '' || 'Insira seu nome',
                          (val) => val != null || 'Insira seu nome',
                          (val) => val != undefined || 'Insira seu nome',
                        ]"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="d-flex ml-1 mt-n5">
                    <v-col cols="4">
                      <v-text-field
                        counter
                        name="cc-exp"
                        autocomplete="cc-exp"
                        maxlength="7"
                        variant="underlined"
                        :color="this.dadosEmpresa.corBase"
                        label="Validade"
                        v-model="valueFields.exp"
                        :rules="[
                          (v) => !!v || 'Validade é obrigatória',
                          (v) =>
                            this.validateExpirationDate(v) ||
                            'Data de validade inválida',
                        ]"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        counter
                        name="cc-cvc"
                        autocomplete="cc-cvc"
                        maxlength="3"
                        variant="underlined"
                        :color="this.dadosEmpresa.corBase"
                        label="CVV"
                        v-model="valueFields.cardCvv"
                        :rules="[(v) => !!v || 'CVV é obrigatório']"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="5">
                      <v-btn
                        color="green"
                        class="mt-5"
                        style="width: 100%"
                        @click="validaCartao"
                        rounded="0"
                        >Enviar</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-dialog>
        <v-dialog v-model="dialogPix" persistent>
          <v-row>
            <v-col cols="11" md="4" class="mx-auto">
              <v-card>
                <v-card-text>
                  <p>QR PIX:</p>
                  <v-row>
                    <v-col cols="12" class="d-flex justify-center">
                      <QRCodeVue3
                        :width="250"
                        :height="250"
                        :value="pix.code"
                        :qrOptions="{
                          typeNumber: 0,
                          mode: 'Byte',
                          errorCorrectionLevel: 'H',
                        }"
                        :imageOptions="{
                          hideBackgroundDots: false,
                          imageSize: 1,
                          margin: 0,
                        }"
                        :dotsOptions="{
                          type: 'extra-rounded',
                          color: '#000000',
                          gradient: {
                            type: 'linear',
                            rotation: 0,
                            colorStops: [
                              { offset: 0, color: '#000f1e' },
                              { offset: 1, color: '#001e36' },
                            ],
                          },
                        }"
                        :backgroundOptions="{ color: '#ffffff' }"
                        :cornersSquareOptions="{
                          type: 'square',
                          color: '#000f1e',
                        }"
                        :cornersDotOptions="{ type: 'none', color: '#000f1e' }"
                        fileExt="png"
                        :image="image"
                        myclass="my-qur"
                        imgclass="img-qr"
                      ></QRCodeVue3>
                    </v-col>
                    <v-col cols="12" class="d-flex justify-center">
                      <v-btn
                        prepend-icon="mdi-content-copy"
                        class="font-weight-bold"
                        variant="plain"
                        :color="dadosEmpresa.corBase"
                        @click="copyText()"
                      >
                        Copiar Linha Digitável
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-col class="d-flex justify-center mt-5" cols="12">
                    <v-btn
                      label="Aceitar"
                      color="green"
                      rounded="3"
                      @click="(dialogWhats = true), (dialogPix = false)"
                      >Pago <v-icon>mdi-check</v-icon></v-btn
                    >
                  </v-col>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-dialog>
        <v-dialog v-model="dialogErroPix" persistent>
          <v-row>
            <v-col cols="11" md="4" class="mx-auto">
              <v-card>
                <v-card-text>
                  <p>
                    Erro ao copiar a linha pix, copie manualmente a linha
                    digitável abaixo:
                  </p>
                  <v-row>
                    <v-col
                      cols="12"
                      class="d-flex justify-center pl-5 pr-5 mt-10"
                      style="
                        background-color: rgba(255, 0, 0, 0.3);
                        border-radius: 10px;
                      "
                    >
                      <p style="max-width: 90%">{{ this.pix.copyLine }}</p>
                    </v-col>
                  </v-row>
                  <v-col class="d-flex justify-center mt-5" cols="12">
                    <v-btn
                      label="Aceitar"
                      color="green"
                      rounded="3"
                      @click="(dialogWhats = true), (dialogErroPix = false)"
                      >Pago <v-icon>mdi-check</v-icon></v-btn
                    >
                  </v-col>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-dialog>
        <v-dialog v-model="dialogWhats">
          <v-col cols="12" md="4" class="mx-auto">
            <v-card class="text-center" height="150">
              <v-card-text
                >Pedido enviado com sucesso. Deseja ser Redirecionado ao
                whatsapp para confirmação?</v-card-text
              >
              <v-card-actions class="d-flex justify-space-around">
                <v-btn
                  class="bg-green"
                  @click="
                    abreWhats(),
                      (dialogWhats = false),
                      (dialogPedidoFinalizado = true)
                  "
                  >Sim</v-btn
                >
                <v-btn
                  class="bg-red"
                  @click="
                    (dialogWhats = false), (dialogPedidoFinalizado = true)
                  "
                  >Não</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-dialog>
        <v-dialog v-model="dialogPedidoFinalizado">
          <v-col cols="12" md="4" class="mx-auto">
            <v-card class="text-center" height="150">
              <v-card-text>Pedido Finalizado</v-card-text>
              <svg
                fill="#06e052"
                height="50px"
                width="50px"
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 512 512"
                xml:space="preserve"
                stroke="#06e052"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <g>
                    <path
                      d="M474.045,173.813c-4.201,1.371-6.494,5.888-5.123,10.088c7.571,23.199,11.411,47.457,11.411,72.1 c0,62.014-24.149,120.315-68,164.166s-102.153,68-164.167,68s-120.316-24.149-164.167-68S16,318.014,16,256 S40.149,135.684,84,91.833s102.153-68,164.167-68c32.889,0,64.668,6.734,94.455,20.017c28.781,12.834,54.287,31.108,75.81,54.315 c3.004,3.239,8.066,3.431,11.306,0.425c3.24-3.004,3.43-8.065,0.426-11.306c-23-24.799-50.26-44.328-81.024-58.047 C317.287,15.035,283.316,7.833,248.167,7.833c-66.288,0-128.608,25.813-175.48,72.687C25.814,127.392,0,189.712,0,256 c0,66.287,25.814,128.607,72.687,175.479c46.872,46.873,109.192,72.687,175.48,72.687s128.608-25.813,175.48-72.687 c46.873-46.872,72.687-109.192,72.687-175.479c0-26.332-4.105-52.26-12.201-77.064 C482.762,174.736,478.245,172.445,474.045,173.813z"
                    ></path>
                    <path
                      d="M504.969,83.262c-4.532-4.538-10.563-7.037-16.98-7.037s-12.448,2.499-16.978,7.034l-7.161,7.161 c-3.124,3.124-3.124,8.189,0,11.313c3.124,3.123,8.19,3.124,11.314-0.001l7.164-7.164c1.51-1.512,3.52-2.344,5.66-2.344 s4.15,0.832,5.664,2.348c1.514,1.514,2.348,3.524,2.348,5.663s-0.834,4.149-2.348,5.663L217.802,381.75 c-1.51,1.512-3.52,2.344-5.66,2.344s-4.15-0.832-5.664-2.348L98.747,274.015c-1.514-1.514-2.348-3.524-2.348-5.663 c0-2.138,0.834-4.149,2.351-5.667c1.51-1.512,3.52-2.344,5.66-2.344s4.15,0.832,5.664,2.348l96.411,96.411 c1.5,1.5,3.535,2.343,5.657,2.343s4.157-0.843,5.657-2.343l234.849-234.849c3.125-3.125,3.125-8.189,0-11.314 c-3.124-3.123-8.189-3.123-11.313,0L212.142,342.129l-90.75-90.751c-4.533-4.538-10.563-7.037-16.98-7.037 s-12.448,2.499-16.978,7.034c-4.536,4.536-7.034,10.565-7.034,16.977c0,6.412,2.498,12.441,7.034,16.978l107.728,107.728 c4.532,4.538,10.563,7.037,16.98,7.037c6.417,0,12.448-2.499,16.977-7.033l275.847-275.848c4.536-4.536,7.034-10.565,7.034-16.978 S509.502,87.794,504.969,83.262z"
                    ></path>
                  </g>
                </g>
              </svg>
              <p>{{ tempoFinalizacao }}</p>
            </v-card>
          </v-col>
        </v-dialog>
      </div>
    </v-col>
  </v-row>
  <div
    v-if="precoTotal > 0"
    height="40"
    :style="`background-color: ${dadosEmpresa.corBase};  position: fixed;
bottom: 0; width: 100%`"
    scroll-target="#scroll-threshold-example"
    class="d-flex justify-center"
  >
    <v-btn
      :disabled="
        this.carrinho.find(
          (val) => val.saborComp && val.saborSelecionado.length == 0,
        )
          ? true
          : false
      "
      @click="validate"
      style="color: white; min-width: 430px; max-width: 550px"
      variant="plain"
      color="white"
    >
      Finalizar compra R$ {{ parseFloat(precoTotal).toFixed(2) }}
    </v-btn>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { store } from "../../store/store";
import stringSimilarity from "string-similarity";
import { maskJs } from "mask-js";
import { useDisplay } from "vuetify";
import pako from "pako"

import axios from "axios";

import geraPix from "../../libs/geraPix";
import QRCodeVue3 from "qrcode-vue3";

var imageT = require("../../assets/logoQR.png");

export default {
  name: "finalizaCompra",
  form: "#form",
  components: {
    QRCodeVue3,
  },
  data() {
    return {
      cardParts: ["", "", "", ""],
      valueFields: {
        cardName: "",
        cardNumber: "",
        cardMonth: null,
        cardYear: null,
        cardCvv: null,
        exp: null,
      },
      mutableMetodosPgto: [],
      ambientesPgto: ["Pagar no app", "Pagar na entrega/retirada"],
      ambientePgto: null,
      dialogCartao: false,
      usaDados: true,
      image: imageT,
      pix: { code: "", copyLine: "" },
      dialogPix: false,
      dialogErroPix: false,
      initialDataConfiguration: null,
      dialogPedidoFinalizado: false,
      tempoFinalizacao: null,
      dialogWhats: false,
      propValueTest: false,
      erroSabor: false,
      valorTele: "0,00",
      isFormValid: false,
      errorCheckboxTroco: "",
      errorCheckboxTele: "",
      errorHorario: "",
      disableCheckboxTroco: false,
      precisaTroco: "false",
      precisaTele: "false",
      dialog: false,
      dialogHorario: false,
      domingoabre: null,
      tercaabre: null,
      quartaabre: null,
      quintaabre: null,
      sextaabre: null,
      sabadoabre: null,
      segundaabre: null,
      prodWpp: null,
      valorTamComposto: [],
      widthPrincipal: null,
      widthCarrinho: null,
      metodoPgto: null,
      cliente: {
        nome: null,
        cpf: "",
        telefone: null,
        endereco: null,
        bairro: null,
        numero: null,
        complemento: ""
      },
      mutableCarrinho: [],
      pedidos: {
        valorTroco: null,
        num: null,
        cliente: null,
        produtos: null,
        metodoPgto: null,
        preco: null,
        status: null,
        data: null,
        clienteNum: null,
        observacao: null,
        dataEntrega: null,
        horaEntrega: null,
      },
    };
  },
  setup() {
    // Destructure only the keys we want to use
    const { xs, mdAndUp } = useDisplay();

    return { xs, mdAndUp };
  },
  computed: {
    currentDate() {
      return new Date();
    },
    formattedCardNumber() {
      const cardNumber = this.valueFields.cardNumber;
      const formatted = cardNumber.replace(/\s/g, "");
      const chunks = [];

      for (let i = 0; i < formatted.length; i += 4) {
        chunks.push(formatted.substr(i, 4));
      }

      return chunks.join(" ").trim(); // Trim any trailing spaces
    },
    ...mapGetters([
      "database",
      "dadosEmpresa",
      "carrinho",
      "categorias",
      "horario",
      "selecionado",
      "precoTotal",
      "produtos",
      "bairros",
      "cidade",
      "metodosPgto",
      "logado",
      "finalizaPedido",
    ]),
  },
  watch: {
    cardParts: {
      handler() {
        this.valueFields.cardNumber = this.cardParts.join(" ");
      },
      deep: true,
    },
    "valueFields.exp"(n) {
      this.valueFields.exp = maskJs("99/9999", n);
      const [inputMonth, inputYear] = this.valueFields.exp
        .split("/")
        .map(Number);
      this.valueFields.cardMonth = inputMonth;
      this.valueFields.cardYear = inputYear;
    },
    "valueFields.cardNumber"(n) {
      this.valueFields.cardNumber = n
        .replace(/\s/g, "")
        .replace(/(.{4})/g, "$1 ");
    },
    finalizaPedido(n) {
      if (n == true) {
        this.validate()
      }
    },
    usaDados(n) {
      this.setDadosCliente(n);
    },
    dialogPedidoFinalizado(n) {
      if (n == true) {
        this.tempoFinalizacao = 3;
        this.interval = setInterval(() => {
          if (this.tempoFinalizacao === 0) {
            clearInterval(this.interval);
            this.dialogPedidoFinalizado = false;
            this.$router.push("/");
            store.commit("incrementCarrinho", []);
          } else {
            this.tempoFinalizacao--;
          }
        }, 1000);
      }
    },
    "pedidos.horaEntrega"() {
      this.getHorarioEntrega();
    },
    "pedidos.dataEntrega"() {
      if (this.pedidos.horaEntrega != null && this.pedidos.horaEntrega != "") {
        this.getHorarioEntrega();
      }
    },
    precisaTroco(n) {
      if (n == "") {
        this.errorCheckboxTrocoTroco = "Escolha uma opção";
        this.disableCheckboxTroco = true;
      } else {
        this.errorCheckboxTroco = "";
        this.disableCheckboxTroco = false;
      }
    },
    precisaTele(n) {
      if (n == "") {
        this.errorCheckboxTele = "Escolha uma opção";
        this.disableCheckboxTele = true;
      } else {
        this.errorCheckboxTele = "";
        this.disableCheckboxTele = false;
      }
    },
    "cliente.bairro"(n) {
      var stop = false;
      if (n != null) {
        for (var grupos of this.dadosEmpresa.grupos) {
          for (var bairro of grupos.bairros) {
            if (bairro.id == n.id) {
              this.valorTele = grupos.valor;
              stop = true;
            } else if (stop == false) {
              this.valorTele = this.dadosEmpresa.valorTele;
            }
          }
        }
        this.enviaPreco();
      }
    },
    "cliente.telefone"(n) {
      const cleanedPhone = n != null ? n.replace(/\D/g, "") : "";
      if (cleanedPhone.length > 10) {
        this.cliente.telefone = maskJs("(99) 9 9999-9999", n);
      } else {
        this.cliente.telefone = maskJs("(99) 9999-9999", n);
      }
    },
    async "cliente.cep"(n) {
      if(n != null){
        const cleanCep = n.replace(/\D/g, "");
        this.cliente.cep = maskJs("99999-999", n);
        if (n.length == 9) {
          {
            const response = await axios({
              method: "get",
              url: `https://viacep.com.br/ws/${cleanCep}/json/`,
            });
            this.cliente.endereco = response.data.logradouro;
            this.cliente.bairro = this.matchBairro(response);
          }
        }
      }
      
    },
    metodoPgto(n) {
      if (n.toLowerCase().match("dinheiro")) {
        this.ambientePgto = "Pagar na entrega/retirada";
      }
    },
    ambientePgto(n) {
      if (n == "Pagar na entrega/retirada") {
        this.mutableMetodosPgto = JSON.parse(JSON.stringify(this.metodosPgto));
      } else {
        this.mutableMetodosPgto = ["Pix", "Crédito"];
      }
    },
  },

  methods: {
    validateExpirationDate(expiration) {
      const [inputMonth, inputYear] = expiration.split("/").map(Number);
      const currentMonth = this.currentDate.getMonth() + 1; // Months are zero-based
      const currentYear = this.currentDate.getFullYear();

      if (
        inputYear < currentYear ||
        (inputYear === currentYear && inputMonth < currentMonth)
      ) {
        return false; // Invalid if year is past or if month is before current month and year
      }

      return true;
    },
    onCardNumberInput() {
      // Remove spaces and update the valueFields.cardNumber
      this.valueFields.cardNumber = this.formattedCardNumber.replace(/\s/g, "");
    },
    handleInputCard(partIndex) {
      const nextPart = partIndex + 1;
      if (
        this.cardParts[partIndex].length === 4 &&
        nextPart < this.cardParts.length
      ) {
        console.log(nextPart);
        this.$refs[`part${nextPart}`][0].focus();
      }
    },
    handleKeydownCard(partIndex, event) {
      const prevPart = partIndex - 1;
      if (
        event.key === "Backspace" &&
        this.cardParts[partIndex].length === 0 &&
        prevPart >= 0
      ) {
        this.$refs[`part${prevPart}`][0].focus();
      }
    },
    matchBairro(response) {
      const bairroNames = this.bairros.map((bairro) => bairro.nome);
      const matches = stringSimilarity.findBestMatch(
        response.data.bairro,
        bairroNames,
      );

      const bestMatch = matches.bestMatch.target;
      const matchedBairro = this.bairros.find(
        (bairro) => bairro.nome === bestMatch,
      );

      return matchedBairro;
    },
    setDadosCliente(n) {
      if (n == true && this.logado.data.nome != "") {
        this.cliente.nome =
        this.logado.data.nome + " " + this.logado.data.sobrenome;
        this.cliente.cpf = this.logado.data.cpf;
        this.cliente.telefone = this.logado.data.telefone;
        this.pedidos.clienteNum = this.logado.data.whatsapp;
        this.cliente.endereco = this.logado.data.endereco;
        this.cliente.bairro = this.logado.data.bairro;
        this.cliente.numero = this.logado.data.numero;
        this.cliente.complemento = this.logado.data.complemento;
      } else if (n == false) {
        this.cliente = {
          nome: '',
          cpf: '',
          telefone: '',
          endereco: '',
          bairro: '',
          numero: '',
          complemento: "",
          cep: ''
        };
      }
    },
    async geraCodigoPix() {
      store.commit("incrementCarregando", true);
      if (
        this.metodoPgto.toLowerCase().match("pix")
      ) {
        if (this.dadosEmpresa.sitef && this.ambientePgto == 'Pagar no app') {
          try {
            let data = {
              empresa: process.env.VUE_APP_DATABASE.toString(),
              merchant_usn:
                this.pedidos.num.toString() + process.env.VUE_APP_DATABASE,
              order_id: this.pedidos.num.toString(),
              amount: this.pedidos.preco,
              type: "pix",
            };
            const response = await axios.post(
              `${process.env.VUE_APP_APIURL}/pagamentos/sitef/start`,
              {
                ...data,
              },
            );
            const result = response.data.data;
            console.log(result);
            if (result.payment ? result.payment.status == "ERR" : false) {
              this.$swal
                .fire({
                  icon: "error",
                  text: "Ocorreu um erro ao gerar o qr code, porém seu pedido foi enviado. Tente gera-lo novamente.",
                  confirmButtonColor: "#388E3C",
                  confirmButtonText: "Tentar novamente",
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    this.geraCodigoPix();
                  }
                });
              console.log(result.payment.authorizer_message);
            } else {
              this.pix = {
                code: result.payment.qr_code,
                copyLine: result.payment.qr_code,
              };
              console.log("Pagamento enviado", result);
              this.dialogPix = true;
            }
          } catch (error) {
            console.log(error, this.pedidos);
            this.$swal.fire({
              icon: "error",
              text: "Erro ao iniciar pagamento",
              confirmButtonColor: "#d33",
            });
          }
        } else {
          geraPix(
            this.dadosEmpresa.chavePix,
            this.dadosEmpresa.nome,
            this.cidade,
            this.pedidos.num,
            `Pedido ${this.pedidos.num}`,
            this.dadosEmpresa.cep.replace('-', ''),
            parseFloat(this.precoTotal),
          ).then((val) => {
            this.pix = {
              code: val.copyLine,
              copyLine: val.copyLine,
            };
            this.dialogPix = true;
          });
        }
      } else if (
        this.ambientePgto.match("Pagar no app") &&
        !this.metodoPgto.toLowerCase().match("dinheiro") &&
        !this.metodoPgto.toLowerCase().match("pix")
      ) {
        this.dialogCartao = true;
      }
      store.commit("incrementCarregando", false);
    },
    validaCartao() {
      this.$refs.formCartao.validate().then(async (val) => {
        if (val.valid) {
          store.commit("incrementCarregando", true);
          try {
            const response = await axios.post(
              `${process.env.VUE_APP_APIURL}/pagamentos/sitef/start`,
              {
                empresa: process.env.VUE_APP_DATABASE.toString(),
                payment_type:
                  this.pedidos.metodoPgto == "Crédito"
                    ? "C"
                    : this.pedidos.metodoPgto == "Débito"
                    ? "D"
                    : "",
                merchant_usn:
                  this.pedidos.num.toString() + process.env.VUE_APP_DATABASE,
                order_id: this.pedidos.num.toString(),
                amount: this.pedidos.preco,
                type: "card",
                card: {
                  number: this.valueFields.cardNumber.replace(/ /g, ""),
                  expiryDate: this.valueFields.exp,
                  security_code: this.valueFields.cardCvv,
                },
              },
            );
            const result = response.data.data;
            if (result.payment ? result.payment.status == "ERR" : false) {
              this.$swal.fire({
                icon: "error",
                text: "Ocorreu um erro ao efetivar o pagamento, porém seu pedido foi enviado. Tente efetiva-lo novamente.",
                confirmButtonColor: "#388E3C",
                confirmButtonText: "Tentar novamente",
              });
              console.log(
                result.payment.authorizer_message
                  ? result.payment.authorizer_message
                  : result,
              );
              store.commit("incrementCarregando", false);
            } else if (
              result.payment ? result.payment.status == "NEG" : false
            ) {
              this.$swal.fire({
                icon: "error",
                text: "Pagamento foi negado, verifique as informações e tente re-enviar.",
                confirmButtonColor: "#388E3C",
                confirmButtonText: "Ok",
              });
              console.log(
                result.payment.authorizer_message
                  ? result.payment.authorizer_message
                  : result,
              );
              store.commit("incrementCarregando", false);
            } else {
              console.log("Pagamento enviado", result);
              store.commit("incrementCarregando", false);
              this.dialogCartao = false;
              this.dialogWhats = true;
            }
          } catch (error) {
            store.commit("incrementCarregando", false);
            console.log(error.response.data.error.issues[0]);
            if (error.response.data.error.issues) {
              for (let issue in error.response.data.error.issues) {
                if (
                  error.response.data.error.issues[issue].message ==
                  "Invalid credit card number"
                ) {
                  this.$swal.fire({
                    icon: "error",
                    text: "Número inválido de cartao",
                    confirmButtonColor: "#d33",
                  });
                }
              }
            } else {
              this.$swal.fire({
                icon: "error",
                text: "Erro ao iniciar pagamento",
                confirmButtonColor: "#d33",
              });
            }
          }
        } else {
          this.$swal.fire({
            icon: "error",
            text: "Formulário inválido",
            confirmButtonColor: "#d33",
          });
        }
      });
      store.commit("incrementCarregando", false);
    },
    copyText() {
      navigator.clipboard
        .writeText(this.pix.copyLine)
        .then(() => {
          alert("Copiado com sucesso.");
        })
        .catch(() => {
          // window.confirm('Erro ao copiar\nCopie o código pix manualmente:\n' + this.pix.copyLine)
          this.dialogErroPix = true;
          this.dialogPix = false;
        });
    },
    getHorarioEntrega() {
      var data = new Date(this.pedidos.dataEntrega);
      data.setDate(data.getDate() + 1);
      var diaSemana = data.getDay();
      var horario = null;
      if (diaSemana == 6) {
        for (var i = 0; i < this.dadosEmpresa.horarios[0].sabado.length; i++) {
          if (
            this.pedidos.horaEntrega <
              this.dadosEmpresa.horarios[0].sabado[i].fecha &&
            this.pedidos.horaEntrega >=
              this.dadosEmpresa.horarios[0].sabado[i].abre &&
            this.dadosEmpresa.horarios[0].sabado[i].abre != "" &&
            this.dadosEmpresa.horarios[0].sabado[i].fecha != ""
          ) {
            (horario = true), (this.errorHorario = "");
          }
        }
        if (horario == null) {
          horario = false;
          (this.errorHorario =
            "Horario de entrega está inválido para o dia selecionado, selecione um horário dentro da escala de funcionamento do estabelecimento."),
            (this.pedidos.horaEntrega = "");
        }
      } else if (diaSemana == 5) {
        for (i = 0; i < this.dadosEmpresa.horarios[0].sexta.length; i++) {
          if (
            this.pedidos.horaEntrega <
              this.dadosEmpresa.horarios[0].sexta[i].fecha &&
            this.pedidos.horaEntrega >=
              this.dadosEmpresa.horarios[0].sexta[i].abre &&
            this.dadosEmpresa.horarios[0].sexta[i].abre != "" &&
            this.dadosEmpresa.horarios[0].sexta[i].fecha != ""
          ) {
            (horario = true), (this.errorHorario = "");
          }
        }
        if (horario == null) {
          horario = false;
          (this.errorHorario =
            "Horario de entrega está inválido para o dia selecionado, selecione um horário dentro da escala de funcionamento do estabelecimento."),
            (this.pedidos.horaEntrega = "");
        }
      } else if (diaSemana == 4) {
        for (i = 0; i < this.dadosEmpresa.horarios[0].quinta.length; i++) {
          if (
            this.pedidos.horaEntrega <
              this.dadosEmpresa.horarios[0].quinta[i].fecha &&
            this.pedidos.horaEntrega >=
              this.dadosEmpresa.horarios[0].quinta[i].abre &&
            this.dadosEmpresa.horarios[0].quinta[i].abre != "" &&
            this.dadosEmpresa.horarios[0].quinta[i].fecha != ""
          ) {
            (horario = true), (this.errorHorario = "");
          }
        }
        if (horario == null) {
          horario = false;
          (this.errorHorario =
            "Horario de entrega está inválido para o dia selecionado, selecione um horário dentro da escala de funcionamento do estabelecimento."),
            (this.pedidos.horaEntrega = "");
        }
      } else if (diaSemana == 3) {
        for (i = 0; i < this.dadosEmpresa.horarios[0].quarta.length; i++) {
          if (
            this.pedidos.horaEntrega <
              this.dadosEmpresa.horarios[0].quarta[i].fecha &&
            this.pedidos.horaEntrega >=
              this.dadosEmpresa.horarios[0].quarta[i].abre &&
            this.dadosEmpresa.horarios[0].quarta[i].abre != "" &&
            this.dadosEmpresa.horarios[0].quarta[i].fecha != ""
          ) {
            (horario = true), (this.errorHorario = "");
          }
        }
        if (horario == null) {
          horario = false;
          (this.errorHorario =
            "Horario de entrega está inválido para o dia selecionado, selecione um horário dentro da escala de funcionamento do estabelecimento."),
            (this.pedidos.horaEntrega = "");
        }
      } else if (diaSemana == 2) {
        for (i = 0; i < this.dadosEmpresa.horarios[0].terca.length; i++) {
          if (
            this.pedidos.horaEntrega <
              this.dadosEmpresa.horarios[0].terca[i].fecha &&
            this.pedidos.horaEntrega >=
              this.dadosEmpresa.horarios[0].terca[i].abre &&
            this.dadosEmpresa.horarios[0].terca[i].abre != "" &&
            this.dadosEmpresa.horarios[0].terca[i].fecha != ""
          ) {
            (horario = true), (this.errorHorario = "");
          }
        }
        if (horario == null) {
          horario = false;
          (this.errorHorario =
            "Horario de entrega está inválido para o dia selecionado, selecione um horário dentro da escala de funcionamento do estabelecimento."),
            (this.pedidos.horaEntrega = "");
        }
      } else if (diaSemana == 1) {
        for (i = 0; i < this.dadosEmpresa.horarios[0].segunda.length; i++) {
          if (
            this.pedidos.horaEntrega <
              this.dadosEmpresa.horarios[0].segunda[i].fecha &&
            this.pedidos.horaEntrega >=
              this.dadosEmpresa.horarios[0].segunda[i].abre &&
            this.dadosEmpresa.horarios[0].segunda[i].abre != "" &&
            this.dadosEmpresa.horarios[0].segunda[i].fecha != ""
          ) {
            (horario = true), (this.errorHorario = "");
          }
        }
        if (horario == null) {
          horario = false;
          (this.errorHorario =
            "Horario de entrega está inválido para o dia selecionado, selecione um horário dentro da escala de funcionamento do estabelecimento."),
            (this.pedidos.horaEntrega = "");
        }
      } else if (diaSemana == 0) {
        for (i = 0; i < this.dadosEmpresa.horarios[0].domingo.length; i++) {
          if (
            this.pedidos.horaEntrega <
              this.dadosEmpresa.horarios[0].domingo[i].fecha &&
            this.pedidos.horaEntrega >=
              this.dadosEmpresa.horarios[0].domingo[i].abre &&
            this.dadosEmpresa.horarios[0].domingo[i].abre != "" &&
            this.dadosEmpresa.horarios[0].domingo[i].fecha != ""
          ) {
            (horario = true), (this.errorHorario = "");
          }
        }
        if (horario == null) {
          horario = false;
          (this.errorHorario =
            "Horario de entrega está inválido para o dia selecionado, selecione um horário dentro da escala de funcionamento do estabelecimento."),
            (this.pedidos.horaEntrega = "");
        }
      }
      (this.domingoabre = null),
        (this.tercaabre = null),
        (this.quartaabre = null),
        (this.quintaabre = null),
        (this.sextaabre = null),
        (this.sabadoabre = null),
        (this.segundaabre = null);

      for (var o = 0; o < this.dadosEmpresa.horarios[0].domingo.length; o++) {
        if (this.dadosEmpresa.horarios[0].domingo[o].abre != "") {
          var domingo =
            this.dadosEmpresa.horarios[0].domingo[o].abre +
            " - " +
            this.dadosEmpresa.horarios[0].domingo[o].fecha;
          if (o == this.dadosEmpresa.horarios[0].domingo.length - 1) {
            this.domingoabre = this.domingoabre + " " + domingo;
          } else {
            this.domingoabre = this.domingoabre + " " + domingo + " ; ";
          }
          this.domingoabre = this.domingoabre.replace(/[()lundefined]/g, "");
        }
      }

      for (o = 0; o < this.dadosEmpresa.horarios[0].segunda.length; o++) {
        if (this.dadosEmpresa.horarios[0].segunda[o].abre != "") {
          var segunda =
            this.dadosEmpresa.horarios[0].segunda[o].abre +
            " - " +
            this.dadosEmpresa.horarios[0].segunda[o].fecha;
          if (o == this.dadosEmpresa.horarios[0].segunda.length - 1) {
            this.segundaabre = this.segundaabre + " " + segunda;
          } else {
            this.segundaabre = this.segundaabre + " " + segunda + " ; ";
          }
          this.segundaabre = this.segundaabre.replace(/[()lundefined]/g, "");
        }
      }

      for (o = 0; o < this.dadosEmpresa.horarios[0].terca.length; o++) {
        if (this.dadosEmpresa.horarios[0].terca[o].abre != "") {
          var terca =
            this.dadosEmpresa.horarios[0].terca[o].abre +
            " - " +
            this.dadosEmpresa.horarios[0].terca[o].fecha;
          if (o == this.dadosEmpresa.horarios[0].terca.length - 1) {
            this.tercaabre = this.tercaabre + " " + terca;
          } else {
            this.tercaabre = this.tercaabre + " " + terca + " ; ";
          }
          this.tercaabre = this.tercaabre.replace(/[()lundefined]/g, "");
        }
      }

      for (o = 0; o < this.dadosEmpresa.horarios[0].quarta.length; o++) {
        if (this.dadosEmpresa.horarios[0].quarta[o].abre != "") {
          var quarta =
            this.dadosEmpresa.horarios[0].quarta[o].abre +
            " - " +
            this.dadosEmpresa.horarios[0].quarta[o].fecha;
          if (o == this.dadosEmpresa.horarios[0].quarta.length - 1) {
            this.quartaabre = this.quartaabre + " " + quarta;
          } else {
            this.quartaabre = this.quartaabre + " " + quarta + " ; ";
          }
          this.quartaabre = this.quartaabre.replace(/[()lundefined]/g, "");
        }
      }

      for (o = 0; o < this.dadosEmpresa.horarios[0].quinta.length; o++) {
        if (this.dadosEmpresa.horarios[0].quinta[o].abre != "") {
          var quinta =
            this.dadosEmpresa.horarios[0].quinta[o].abre +
            " - " +
            this.dadosEmpresa.horarios[0].quinta[o].fecha;
          if (o == this.dadosEmpresa.horarios[0].quinta.length - 1) {
            this.quintaabre = this.quintaabre + " " + quinta;
          } else {
            this.quintaabre = this.quintaabre + " " + quinta + " ; ";
          }
          this.quintaabre = this.quintaabre.replace(/[()lundefined]/g, "");
        }
      }

      for (o = 0; o < this.dadosEmpresa.horarios[0].sexta.length; o++) {
        if (this.dadosEmpresa.horarios[0].sexta[o].abre != "") {
          var sexta =
            this.dadosEmpresa.horarios[0].sexta[o].abre +
            " - " +
            this.dadosEmpresa.horarios[0].sexta[o].fecha;
          if (o == this.dadosEmpresa.horarios[0].sexta.length - 1) {
            this.sextaabre = this.sextaabre + " " + sexta;
          } else {
            this.sextaabre = this.sextaabre + " " + sexta + " ; ";
          }
          this.sextaabre = this.sextaabre.replace(/[()lundefined]/g, "");
        }
      }

      for (o = 0; o < this.dadosEmpresa.horarios[0].sabado.length; o++) {
        if (this.dadosEmpresa.horarios[0].sabado[o].abre != "") {
          var sabado =
            this.dadosEmpresa.horarios[0].sabado[o].abre +
            " - " +
            this.dadosEmpresa.horarios[0].sabado[o].fecha;
          if (o == this.dadosEmpresa.horarios[0].sabado.length - 1) {
            this.sabadoabre = this.sabadoabre + " " + sabado;
          } else {
            this.sabadoabre = this.sabadoabre + " " + sabado + " ; ";
          }
          this.sabadoabre = this.sabadoabre.replace(/[()lundefined]/g, "");
        }
      }
    },
    coloca0Antes(n, width, z) {
      z = z || "0";
      n = n + "";
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join(z) + n;
    },
    validate() {
      this.$refs.form.validate().then((val) => {
        if (val.valid) {
          this.pedidos.valorTroco = this.precisaTele != "true" ? null : this.pedidos.valorTroco;
          this.validacoes();
        } else {
          this.$swal.fire({
            icon: "error",
            text: "Formulário inválido",
            confirmButtonColor: "#d33",
          });
        }
      });
    },
    validacoes(a) {
      var minDiasData = new Date();
      var dias = [];

      for (var produto of this.mutableCarrinho) {
        if (produto.tempoExtra && produto.tempoExtra.ativo == true) {
          dias.push(produto.tempoExtra.dias);
        }
      }
      var tempoExtra = dias != "" ? Math.max(dias) : null;
      minDiasData.setDate(
        minDiasData.getDate() +
          parseInt(
            tempoExtra != null ? tempoExtra : this.dadosEmpresa.minDiaEncomenda,
          ),
      );
      minDiasData = minDiasData.toISOString().split("T")[0];
      if (this.errorHorario != "" && this.selecionado == "Encomendas") {
        this.$swal.fire({
          icon: "error",
          text: "Formulário inválido",
          confirmButtonColor: "#d33",
        });
      } else if (
        this.mutableCarrinho.find((val) => val.encomenda == true) &&
        this.pedidos.dataEntrega == null &&
        this.selecionado == "Encomendas"
      ) {
        this.$swal.fire({
          icon: "error",
          text: "Selecione a data de entrega",
          confirmButtonColor: "#d33",
        });
      } else if (
        this.mutableCarrinho.find((val) => val.encomenda == true) &&
        this.pedidos.horaEntrega == null &&
        this.selecionado == "Encomendas"
      ) {
        this.$swal.fire({
          icon: "error",
          text: "Selecione a hora de entrega",
          confirmButtonColor: "#d33",
        });
      } else if (
        this.precisaTele == "true" &&
        this.cliente.endereco.length < 8
      ) {
        this.$swal.fire({
          icon: "error",
          text: "Informe um endereço válido",
          confirmButtonColor: "#d33",
        });
      } else if (this.validaCpf() == false || this.validaCpf() == undefined || this.cliente.cpf == null) {
        this.$swal.fire({
          icon: "error",
          text: "Informe um cpf válido",
          confirmButtonColor: "#d33",
        });
      } else if (
        this.selecionado == "Encomendas" &&
        this.mutableCarrinho.find((val) => val.encomenda == true) &&
        this.pedidos.dataEntrega &&
        this.pedidos.dataEntrega < new Date().toISOString().split("T")[0]
      ) {
        this.$swal.fire({
          icon: "error",
          text: "Data entrega precisa ser maior que data atual",
          confirmButtonColor: "#d33",
        });
      } else if (
        this.selecionado == "Encomendas" &&
        minDiasData > this.pedidos.dataEntrega
      ) {
        this.$swal.fire({
          icon: "error",
          text: `Data de entrega precisa ser no mínimo em ${
            tempoExtra != null ? tempoExtra : this.dadosEmpresa.minDiaEncomenda
          } dias.`,
          confirmButtonColor: "#d33",
        });
      } else if (this.metodoPgto == null) {
        this.$swal.fire({
          icon: "error",
          text: "Selecione o método de pagamento",
          confirmButtonColor: "#d33",
        });
      } else {
        this.dialog = !this.dialog;
        if (a == "aceito") {
          this.setPedidos();
        }
      }
    },
    testeMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent,
        )
      ) {
        return true;
      }
    },
    duplicarProduto(prod, index) {
      var produto = JSON.parse(JSON.stringify(prod));
      this.mutableCarrinho.splice(index + 1, 0, produto);
      if (produto.adicionaisSelecionados) {
        produto.adicionaisSelecionados = [];
      }
      this.enviaPreco();
    },
    isMobile() {
      if (this.$isMobile()) {
        this.widthPrincipal = "30em";
        this.widthCarrinho = "370";
        this.widthBtn = "185";
        return true;
      } else {
        this.widthPrincipal = "50em";
        this.widthCarrinho = "430";
        this.widthBtn = "430";
        return false;
      }
    },
    //Insere o pedido no banco de dados
    async setPedidos() {
      store.commit("incrementCarregando", true);
      if(this.pedidos.dataEntrega == null){
        this.pedidos.horaEntrega = null
      }
      try {
        this.pedidos.num = this.pedidos.num ? this.pedidos.num.toString() : "";
        this.pedidos.usuario = {
          logado: this.logado.data.nome != "" ? true : false,
          usouDados: this.usaDados,
          dashboard: false,
        };
        if (this.precisaTele === "true") {
          this.pedidos.valorTele = parseFloat(
            this.valorTele.replace(",", "."),
          ).toFixed(2);
        }

        this.pedidos.metodoPgto = this.metodoPgto;
        this.pedidos.dadosCliente = this.cliente;
        this.pedidos.produtos = this.mutableCarrinho;

        for (var i = 0; i < this.pedidos.produtos.length; i++) {
          this.pedidos.produtos[i].nomeSemTamanho =
            this.pedidos.produtos[i].nome;
          this.pedidos.produtos[i].nome = this.pedidos.produtos[i].nomeTamanho
            ? this.pedidos.produtos[i].nomeTamanho
            : this.pedidos.produtos[i].nome;
        }

        this.pedidos.preco = this.precoTotal;
        this.pedidos.clienteNum =
          this.pedidos.clienteNum == null
            ? "55" + this.cliente.telefone.replace(/[() -]/g, "")
            : this.pedidos.clienteNum;

        this.pedidos.data = new Date()
          .toJSON()
          .substring(0, 10)
          .replace("T", " ");
        this.pedidos.ambientePgto = this.ambientePgto;
        let pedido = pako.deflate(JSON.stringify({pedido: this.pedidos, empresa: process.env.VUE_APP_DATABASE}));
        const response = await axios.post(
          `${process.env.VUE_APP_APIURL}/pedidosdelivery/insertdata`,
          {
            data: pedido
          });

        const result = response.data.result;

        this.pedidos.num = result.data.num;
        for (i = 0; i < this.pedidos.produtos.length; i++) {
          this.pedidos.produtos[i].nome = this.pedidos.produtos[i]
            .nomeSemTamanho
            ? this.pedidos.produtos[i].nomeSemTamanho
            : this.pedidos.produtos[i].nome;
        }
        this.geraCodigoPix();
        console.log("Pedido válido", result);
        store.commit("incrementCarregando", false);
      } catch (error) {
        this.dialogWhats = false,
        this.$swal.fire({
          icon: "error",
          text: "Erro ao enviar pedido",
          confirmButtonColor: "#d33",
        });
        console.log("Invalid Request", error.message);
        store.commit("incrementCarregando", false);
      }
    },
    async abreWhats() {
      this.pedidos.produtos = this.mutableCarrinho;
      this.pedidos.metodoPgto = this.metodoPgto;

      for (var i = 0; i < this.pedidos.produtos.length; i++) {
        if (this.prodWpp == null) {
          this.prodWpp =
            "Numero: " +
            this.pedidos.num +
            "\n" +
            "Nome: " +
            this.cliente.nome +
            [
              this.cliente.endereco
                ? "\nEndereço: " + this.cliente.endereco
                : "",
            ] +
            "\nMétodo de pagamento: " +
            this.pedidos.metodoPgto;
          if (this.pedidos.valorTroco) {
            this.prodWpp += "\nTroco para (R$): R$ " + this.pedidos.valorTroco;
          }
          this.prodWpp =
            this.prodWpp +
            "\n" +
            "Modo de entrega: " +
            (this.pedidos.valorTele ? "Tele" : "Retirada");
          if (this.pedidos.valorTele) {
            this.prodWpp =
              this.prodWpp +
              "\n" +
              "Valor Tele: " +
              "R$ " +
              this.pedidos.valorTele;
          }
          this.prodWpp +=
            "\nValor total: R$ " +
            parseFloat(this.precoTotal).toFixed(2) +
            "\nPedido: \n\n";
          this.prodWpp += this.pedidos.produtos[i].nomeTamanho
            ? this.pedidos.produtos[i].nomeTamanho +
              " x " +
              this.pedidos.produtos[i].quantidade
            : this.pedidos.produtos[i].nome +
              " x " +
              this.pedidos.produtos[i].quantidade;
          if (this.pedidos.produtos[i].adicionaisDesc != undefined) {
            this.prodWpp +=
              "\n" + "Adicionais: " + this.pedidos.produtos[i].adicionaisDesc;
          }
          if (this.pedidos.produtos[i].saboresDesc != undefined) {
            this.prodWpp +=
              "\n" + "Sabores: " + this.pedidos.produtos[i].saboresDesc;
          }
          this.prodWpp += "\n\n";
          console.log(this.prodWpp);
        } else {
          this.prodWpp += this.pedidos.produtos[i].nomeTamanho
            ? this.pedidos.produtos[i].nomeTamanho +
              " x " +
              this.pedidos.produtos[i].quantidade
            : this.pedidos.produtos[i].nome +
              " x " +
              this.pedidos.produtos[i].quantidade;
          if (this.pedidos.produtos[i].adicionaisDesc != undefined) {
            this.prodWpp +=
              "\n" + "Adicionais: " + this.pedidos.produtos[i].adicionaisDesc;
          }
          if (this.pedidos.produtos[i].saboresDesc != undefined) {
            this.prodWpp +=
              "\n" + "Sabores: " + this.pedidos.produtos[i].saboresDesc;
          }
          this.prodWpp += i == this.pedidos.produtos.length - 1 ? "\n" : "\n\n";
        }
        if (i == this.pedidos.produtos.length - 1 && this.pedidos.observacao) {
          this.prodWpp =
            this.prodWpp + "\n" + "Observações: \n" + this.pedidos.observacao;
        }
        if (i == this.pedidos.produtos.length - 1 && this.pedidos.dataEntrega) {
          this.prodWpp =
            this.prodWpp +
            "\n" +
            "Data de Entrega: \n" +
            this.pedidos.dataEntrega.split("-").reverse().join("/") +
            "\n" +
            "Hora de Entrega: \n" +
            this.pedidos.horaEntrega;
        }
      }
      this.prodWpp = window.encodeURIComponent(this.prodWpp);

      window.open(
        "https://api.whatsapp.com/send?phone=" +
          this.dadosEmpresa.whats +
          "&text=" +
          this.prodWpp,
      );
      this.clienteWpp = null;
      this.prodWpp = null;
      this.pedidos.valorTroco = null;
      this.pedidos.observacao = null;
      this.limpaForm();
    },
    limpaForm() {
      (this.pedidos.dataEntrega = null),
        (this.pedidos.horaEntrega = null),
        (this.cliente.nome = ""),
        (this.cliente.cpf = ""),
        (this.cliente.telefone = ""),
        (this.cliente.endereco = ""),
        (this.metodoPgto = "");
    },
    validaCpf() {
      if (this.cliente.cpf.length == 11) {
        var cpf = this.cliente.cpf.trim();
        var p = 0;
        var i = 0;
        var v1 = 0;
        var v2 = 0;
        var aux = false;

        for (i = 1; cpf.length > i; i++) {
          if (cpf[i - 1] != cpf[i]) {
            aux = true;
          }
        }

        if (aux == false) {
          return false;
        }

        for (i = 0, p = 10; cpf.length - 2 > i; i++, p--) {
          v1 += cpf[i] * p;
        }

        v1 = (v1 * 10) % 11;

        if (v1 == 10) {
          v1 = 0;
        }

        if (v1 != cpf[9]) {
          return false;
        }

        for (i = 0, p = 11; cpf.length - 1 > i; i++, p--) {
          v2 += cpf[i] * p;
        }

        v2 = (v2 * 10) % 11;

        if (v2 == 10) {
          v2 = 0;
        }

        if (v2 != cpf[10]) {
          return false;
        } else {
          return true;
        }
      }
    },
    enviaPreco() {
      setTimeout(() => {
        let produtos = this.produtos;

        this.mutableprecoTotal = 0;
        for (var i = 0; i < this.mutableCarrinho.length; i++) {
          if (this.mutableCarrinho[i].codbarras) {
            produtos.find(
              (val) => val.codbarras == this.mutableCarrinho[i].codbarras,
            ).quantidade = this.mutableCarrinho[i].quantidade;
          }
          if (this.mutableCarrinho[i].tamSelecionado) {
            this.mutableprecoTotal += parseFloat(
              this.mutableCarrinho[i].tamSelecionado.valor.replace(",", ".") *
                this.mutableCarrinho[i].quantidade,
            );
            this.mutableCarrinho[i].valor = parseFloat(
              this.mutableCarrinho[i].tamSelecionado.valor.replace(",", "."),
            );
            for (
              var o = 0;
              o < this.mutableCarrinho[i].valorTamComposto.length;
              o++
            ) {
              if (
                this.mutableCarrinho[i].valorTamComposto[o].valor ==
                this.mutableCarrinho[i].tamSelecionado.valor
              ) {
                this.mutableCarrinho[i].nomeTamanho =
                  this.mutableCarrinho[i].nome +
                  " " +
                  this.mutableCarrinho[i].valorTamComposto[o].descricao;
              }
            }
          }
          if (this.mutableCarrinho[i].saborSelecionado) {
            this.mutableCarrinho[i].saboresDesc = "";
            this.mutableCarrinho[i].valorSaboresDesc = 0;

            for (var saborSelecionado of this.mutableCarrinho[i]
              .saborSelecionado) {
              this.mutableCarrinho[i].valorSaboresDesc += parseFloat(
                saborSelecionado.valor.replace(",", ".") *
                  this.mutableCarrinho[i].quantidade,
              );
              this.mutableprecoTotal += parseFloat(
                saborSelecionado.valor.replace(",", ".") *
                  this.mutableCarrinho[i].quantidade,
              );
              if (!this.mutableCarrinho[i].saboresDesc) {
                this.mutableCarrinho[i].saboresDesc =
                  saborSelecionado.descricao;
              } else {
                this.mutableCarrinho[i].saboresDesc +=
                  ", " + saborSelecionado.descricao;
              }
            }
          }
          if (this.mutableCarrinho[i].adicionaisSelecionados != undefined) {
            this.pedidos.possuiAdicionais = true;
            this.mutableCarrinho[i].valorAdicionaisDesc = 0;
            for (
              var c = 0;
              c < this.mutableCarrinho[i].adicionaisSelecionados.length;
              c++
            ) {
              this.mutableCarrinho[i].valorAdicionaisDesc += parseFloat(
                this.mutableCarrinho[i].adicionaisSelecionados[c].valor.replace(
                  ",",
                  ".",
                ) * this.mutableCarrinho[i].quantidade,
              );
              this.mutableprecoTotal += parseFloat(
                this.mutableCarrinho[i].adicionaisSelecionados[c].valor.replace(
                  ",",
                  ".",
                ) * this.mutableCarrinho[i].quantidade,
              );
            }
            this.descricaoAdicionais(i);
          }

          if (
            this.mutableCarrinho[i].tamanhoUnic == true ||
            (!this.mutableCarrinho[i].tamanhoUnic &&
              !this.mutableCarrinho[i].tamSelecionado)
          ) {
            this.mutableprecoTotal += parseFloat(
              this.mutableCarrinho[i].valor.replace(",", ".") *
                this.mutableCarrinho[i].quantidade,
            );
          }
        }
        if (this.precisaTele == "true") {
          this.mutableprecoTotal =
            this.mutableprecoTotal +
            parseFloat((this.valorTele ? this.valorTele : 0).replace(",", "."));
        } else {
          this.mutableprecoTotal += 0;
        }

        store.commit(
          "incrementPrecoTotal",
          parseFloat(this.mutableprecoTotal).toFixed(2),
        );
        store.commit("incrementProdutos", produtos);
        store.commit("incrementCarrinho", this.mutableCarrinho);
      }, 0);
    },
    descricaoAdicionais(i) {
      this.mutableCarrinho[i].adicionaisDesc = null;
      for (var b = 0; b < this.mutableCarrinho[i].valorAdicionais.length; b++) {
        for (
          var c = 0;
          c < this.mutableCarrinho[i].adicionaisSelecionados.length;
          c++
        ) {
          if (
            this.mutableCarrinho[i].valorAdicionais[b].descricao ==
            this.mutableCarrinho[i].adicionaisSelecionados[c].descricao
          ) {
            if (this.mutableCarrinho[i].adicionaisDesc == null) {
              this.mutableCarrinho[i].adicionaisDesc =
                this.mutableCarrinho[i].valorAdicionais[b].descricao;
            } else {
              this.mutableCarrinho[i].adicionaisDesc +=
                ", " + this.mutableCarrinho[i].valorAdicionais[b].descricao;
            }
          }
        }
      }
    },
    initialState() {
      return {
        initialDataConfiguration: null,
        dialogPedidoFinalizado: false,
        tempoFinalizacao: null,
        dialogWhats: false,
        propValueTest: false,
        erroSabor: false,
        valorTele: "0,00",
        isFormValid: false,
        errorCheckboxTroco: "",
        errorCheckboxTele: "",
        errorHorario: "",
        disableCheckboxTroco: false,
        precisaTroco: "false",
        precisaTele: "false",
        dialog: false,
        dialogHorario: false,
        domingoabre: null,
        tercaabre: null,
        quartaabre: null,
        quintaabre: null,
        sextaabre: null,
        sabadoabre: null,
        segundaabre: null,
        prodWpp: null,
        valorTamComposto: [],
        widthPrincipal: null,
        widthCarrinho: null,
        metodoPgto: null,
        cliente: {
          nome: null,
          cpf: "",
          telefone: null,
          endereco: null,
          bairro: null,
        },
        pedidos: {
          valorTroco: null,
          num: null,
          cliente: null,
          produtos: null,
          metodoPgto: null,
          preco: null,
          status: null,
          data: null,
          clienteNum: null,
          observacao: null,
          dataEntrega: null,
          horaEntrega: null,
        },
      };
    },
  },
  activated() {
    this.usaDados = this.logado.data.nome != "" ? true : false;
    this.setDadosCliente(this.usaDados);
    this.$refs.form.reset();
    this.$refs.form.resetValidation();
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.mutableCarrinho = JSON.parse(JSON.stringify(this.carrinho));
    this.enviaPreco();
  },
  deactivated() {
    console.log(1);
    setTimeout(() => {
      Object.assign(this.$data, this.initialState());
    }, 0);
  },
  mounted() {

    this.mutableMetodosPgto = JSON.parse(JSON.stringify(this.metodosPgto));
    this.usaDados = this.logado.data.nome != "" ? true : false;

    this.mutableCarrinho = JSON.parse(JSON.stringify(this.carrinho));
    this.enviaPreco();
    if (this.mutableCarrinho == "") {
      this.$router.push("/");
    }
  },
  created() {
    window.scrollTo({ top: 0, behavior: "smooth" });

    this.isMobile();
  },
};
</script>
<style>
.v-list-item--link::before {
  background-color: red;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  opacity: 1;
  display: block;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' style='width:24px;height:24px' viewBox='0 0 24 24'%3E%3Cpath fill='currentColor' d='M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z' /%3E%3C/svg%3E");
  background-color: transparent;
  background-size: 100%;
  width: 20px;
  height: 20px;
  border-width: thin;
}

.right .v-input__control {
  justify-content: end;
}

.left .v-input__control {
  justify-content: start;
}

.v-select .v-select__selection-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.v-list .v-list-item .v-list-item__content .v-list-item-title {
  overflow: hidden !important;
  overflow-wrap: break-word !important;
  white-space: unset !important;
}

.v-list {
  max-height: 200px;
}
</style>
